<template>
    <el-row>
        <el-form :model="bondGoodsForm"
                 ref="bondGoodsRef"
                 :rules="rules"
                 addAction="/businessIntranet/refundBusinessBondOrder.action"
                 editAction="/businessIntranet/refundBusinessBondOrder.action"
                 label-width="150px"
                 style="width:40%"
                 v-form>
            <el-form-item label="退保证金：" prop="totalMoney">
                <el-input type="number" v-model="bondGoodsForm.totalMoney"  placeholder="请输入退保证金"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary">确定</el-button>
                <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
        </el-form>
    </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import EmployeeSelect from '@/components/EmployeeSelect'

export default {
  name: 'refundBusinessBond',
  extends: BasicPager,
  components: { EmployeeSelect },
  data: function () {
    let checkDecima = (rule, value, callback) => {
      if (value < 0) {
        return callback(new Error('请填写大于0的数值'))
      }

      let match = (value + '').match(/^\d+(\.\d{1,2})?$/)
      if (!match) {
        return callback(new Error('小数点只能保留两位哦！'))
      }
      callback()
    }
    return {
      rules: {
        totalMoney: [{
          required: true,
          message: '请输入退保证金金额'
        },
        { validator: checkDecima, trigger: 'blur' }
        ]
      },
      bondGoodsForm: {
        businessId: null,
        totalMoney: null

      }
    }
  },
  created () {
    this.bondGoodsForm.businessId = this.$route.query.businessId
  },
  methods: {
    onFilterParams: function (params) {
      params.totalMoney = parseInt(params.totalMoney * 100)
    },
    onSelectInfo: function (dataInfo) {

    }
  }

}
</script>

<style scoped>

</style>
